// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kbw-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
  width: 400px;
  max-width: calc(100vw - 48px);
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.kbw-ok,
.kbw-err {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-weight: 700;
  font-size: 13px;
}
.kbw-ok {
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.kbw-err {
  background: #fee2e2;
  color: #dc2626;
}
.kbw-sugg {
  background: var(--v2-blue-bg);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/features/kb-watch/kb-watch.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".kbw-toast {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1000;\n  width: 400px;\n  max-width: calc(100vw - 48px);\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.kbw-ok,\n.kbw-err {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  font-weight: 700;\n  font-size: 13px;\n}\n.kbw-ok {\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.kbw-err {\n  background: #fee2e2;\n  color: #dc2626;\n}\n.kbw-sugg {\n  background: var(--v2-blue-bg);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
